import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIgdChartsDataContext } from './hooks/useIgdChartsDataContext';

export const SchoolAttendanceAnual = () => {
    const { chartData } = useIgdChartsDataContext();


    return (
        <SimpleBars
            title={'Taxa de Acompanhamento de Frequência Escolar (Anual)'}
            horizontal={false}
            subtitles={chartData?.schoolAttendanceAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.schoolAttendanceAnual?.map((item) => item.value  ||  0)}
        />
    );
};
